import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDialogComponent } from '../app/shared/components/confirm-dialog.component';



@Injectable({
  providedIn: 'root'
})
export class DialogService {
  constructor(private modalService: NgbModal) {}

  confirm(message: string, title = 'Confirmação'): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmDialogComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });

    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;

    return modalRef.result
      .then((result) => result === true)
      .catch(() => false);
  }
}
